import React from "react";
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Nav from "../../components/Nav";
import MobileNav from "../../components/MobileNav-Admin";
import SideNavItem from "../../components/SideNavItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilePhoto } from "../../store/AthleteActions";
import { useAxiosInstance } from "../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useResponsiveHeight } from "../../hooks/useResponsiveHeight";

function UniversityLayout() {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();
  const { profilePhoto } = useSelector((state) => state.athletes);

  const [profilePicture, setProfilePicture] = useState(null);
  const { height } = useResponsiveHeight();

  useEffect(() => {
    if (authUser && authUser?.user.role === "admin") {
      dispatch(fetchProfilePhoto(apiInstance, authUser?.user.id));
    }
  }, [dispatch, apiInstance, authUser]);

  useEffect(() => {
    if (profilePhoto) {
      setProfilePicture(profilePhoto);
    }
  }, [profilePhoto]);
  return (
    authUser && (
      <>
        <div className="h-screen flex flex-col">
          <div className="px-0 md:px-4 bg-black">
            <Nav />
          </div>
          <div className="flex flex-row h-full">
            <div className="w-[300px] bg-[#545353] flex-col h-screen hidden sm:hidden md:hidden lg:hidden xl:block">
              {/* Profile info (image/name) */}
              <div className="w-[300px]">
                <div className="w-[100px] h-[105px] min-h-[100px] mx-auto mt-8 border-2 rounded-md border-gray-500 overflow-hidden">
                  <img
                    alt="profile"
                    src={profilePicture?.fileUrl || "/default-profile-img.png"}
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
              <p className="text-red-500 uppercase text-center text-xl mt-4 font-light">
                {authUser?.user.firstName} {authUser?.user.lastName}
              </p>
              <hr className="w-4/5 mx-auto mt-4" />
              {/* Links */}
              <div className="flex flex-col">
                <SideNavItem
                  route={"/admin/dashboard"}
                  displayText={"Dashboard"}
                />
                <SideNavItem
                  route={"/admin/athletes"}
                  displayText={"Athletes"}
                />
                <SideNavItem route={"/admin/coaches"} displayText={"Coaches"} />
                <SideNavItem
                  route={"/admin/combine"}
                  displayText={"Combines"}
                />
                <SideNavItem
                  route={"/admin/candidate-athletes"}
                  displayText={"Potential Athlete"}
                />
                <SideNavItem
                  route={"/admin/duplicate-users"}
                  displayText={"Duplicate Users"}
                />
                <SideNavItem
                  route={"/admin/calendar"}
                  displayText={"Calendar"}
                />
                <SideNavItem
                  route={"/admin/settings"}
                  displayText={"Settings"}
                />
                <SideNavItem route={"/admin/account"} displayText={"Account"} />
              </div>
            </div>
            {/* Mobile bottom nov bar start */}
            <MobileNav />
            <div
              className=" flex-grow pb-3 xl:pb-0 lg:pb-0 h-full"
              style={{ height: `${height}px` }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </>
    )
  );
}

export default UniversityLayout;
